module.exports = __webpack_public_path__ + "img/juryinfo.e5f57a2a.png";